/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";

/*import url and gateway methods */
import { deleteData, getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import time calculation
import { calculateEndTime, getCurrentTime } from "helper/TimeCalculation";
import { getDuration } from "helper/EventHelper/EventHelper";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";
import GoogleCalendarSync from "components/Common/GoogleCalendarSync";

const SaveAgendaModal = ({
  onModalClose,
  setSelectedAgendaId,
  selectedAgendaId,
  setIsDateSpecific,
  isDateSpecific,
  selectedCalendarAgendaDate,
  setSelectedCalendarAgendaDate,
}) => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); // for translations

  // Add view mode state
  const [isViewMode, setIsViewMode] = useState(false);
  const [agendaDetails, setAgendaDetails] = useState(null);
  const [isLoadingAgenda, setIsLoadingAgenda] = useState(false);

  const [agendaTitle, setagendaTitle] = useState("Available");
  const [agendaDate, setagendaDate] = useState("");
  const [startTime, setstartTime] = useState(getCurrentTime());
  const [endTime, setendTime] = useState(getCurrentTime());
  const [location, setLocation] = useState("");
  const [roomOptions, setRoomOptions] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null); // Add room state after location
  const [company, setCompany] = useState(null);
  const [isDateSpecificFromApi, setIsDateSpecificFromApi] = useState(false);

  /* hooks for validation */
  const [validation, setValidation] = useState({
    titleWarning: false,
    dateWarning: false,
    startTimeWarning: false,
    endTimeWarning: false,
    timeDiffWarning: false,
  });

  // validate =========================
  const validate = () => {
    let isValid = true;

    if (agendaTitle === "") {
      setValidation((prevState) => ({ ...prevState, titleWarning: true }));
      isValid = false;
    }

    if (agendaDate == "") {
      setValidation((prevState) => ({ ...prevState, dateWarning: true }));
      isValid = false;
    }

    if (startTime == "") {
      setValidation((prevState) => ({
        ...prevState,
        startTimeWarning: true,
      }));
      isValid = false;
    }

    if (endTime == "") {
      setValidation((prevState) => ({
        ...prevState,
        endTimeWarning: true,
      }));
      isValid = false;
    }

    if (startTime !== "" && endTime !== "") {
      if (startTime > endTime) {
        setValidation((prevState) => ({
          ...prevState,
          timeDiffWarning: true,
        }));
        isValid = false;
      }
    }

    return isValid;
  };

  // Helper function to calculate duration in minutes
  const calculateDurationInMinutes = (start, end) => {
    if (!start || !end) return 0;
    const startTime = new Date(`1970-01-01T${start}:00`);
    const endTime = new Date(`1970-01-01T${end}:00`);
    return Math.round((endTime - startTime) / (1000 * 60));
  };

  //get agenda details
  const getAgendaDetails = async () => {
    try {
      setIsLoadingAgenda(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_DETAILS_AGENDA +
        `/${selectedAgendaId}`;

      console.log("agenda details url--->", requestUrl);

      const response = await getData(requestUrl);

      // console.log("agenda details response--->", response);

      if (response.status) {
        const details = response.data;

        setAgendaDetails(details);
        setagendaTitle(details.description);
        setagendaDate(details.date);
        setstartTime(details.starttime);
        setendTime(details.endtime);
        setLocation(details.location);
        setIsDateSpecificFromApi(details.datespecifichours);
        setCompany(details?.companyvalue || null);
        setSelectedRoom(details.roomvalue);
        loadRoomOptions(details?.companyid?.value);

        // Set view mode if agenda exists
        setIsViewMode(!!selectedAgendaId);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoadingAgenda(false);
    }
  };

  // Async load options for companies
  const loadCompanyOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?filtername=${inputValue}`;

      const response = await getData(requestUrl);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  //load room options
  const loadRoomOptions = async (clinicId) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_ROOMS +
        `?clinicid=${clinicId}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setRoomOptions(response.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoadingAgenda(false);
    }
  };



  //save agenda
  const saveAgendaHandler = async () => {
    if (validate()) {
      try {
        let agendaData = {
          description: agendaTitle == "" ? "Available" : agendaTitle,
          location: location,
          roomid: selectedRoom?.value || null,
          userid: params.id,
          companyid: company?.value || null,
          date: agendaDate,
          starttime: startTime,
          endtime: endTime,
          duration: getDuration(startTime, endTime),
          availability: true,
          datespecifichours: isDateSpecificFromApi
            ? isDateSpecificFromApi
            : isDateSpecific
              ? true
              : false,
          attendants: [],
        };

        console.log("agenda data----->", agendaData);

        let requestUrl = url.API_BASE_URL;

        let response = null;

        if (selectedAgendaId) {
          requestUrl =
            requestUrl +
            url.API_UPDATE_AGENDA +
            `/${selectedAgendaId}`;

          console.log(requestUrl);

          response = await putData(requestUrl, agendaData);

          console.log(response);
        } else {
          requestUrl = requestUrl + url.API_ADD_NEW_AGENDA;

          console.log(requestUrl);

          response = await postData(requestUrl, agendaData);

          console.log(response);
        }

        if (response.status) {
          resetHandler();

          //hide member modal
          const bootstrapModal = document.querySelector("#saveAccountAgenda");
          const modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();

          onModalClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
    }
  };

  //delete agenda
  const deleteAgendaHandler = async () => {
    if (selectedAgendaId) {
      try {
        let requestUrl =
          url.API_BASE_URL +
          url.API_DELETE_AGENDA +
          `/${selectedAgendaId}`;

        const response = await deleteData(requestUrl);

        if (response.status) {
          resetHandler();

          //hide member modal
          const bootstrapModal = document.querySelector("#saveAccountAgenda");
          const modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();

          onModalClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  //reset
  const resetHandler = () => {
    setValidation({
      titleWarning: false,
      dateWarning: false,
      startTimeWarning: false,
      endTimeWarning: false,
    });

    setagendaTitle("Available");
    setagendaDate("");
    setstartTime(getCurrentTime());
    setendTime(getCurrentTime());
    setLocation("");
    setRoomOptions([]);
    setSelectedRoom(null);
    setCompany(null);
    setSelectedAgendaId(null);
    setIsDateSpecific(false);
    setSelectedCalendarAgendaDate("");
    setIsViewMode(false);
    setAgendaDetails(null);
    setIsLoadingAgenda(false);
  };

  // Toggle between view and edit modes
  const toggleViewMode = () => {
    setIsViewMode(!isViewMode);
  };

  useEffect(() => {
    if (selectedAgendaId) {
      getAgendaDetails();
    }
  }, [selectedAgendaId]);

  useEffect(() => {
    if (selectedCalendarAgendaDate != "") {
      setagendaDate(selectedCalendarAgendaDate);
    }
  }, [selectedCalendarAgendaDate]);

  return (
    <div
      className="modal fade"
      id="saveAccountAgenda"
      tabIndex="-1"
      aria-labelledby="saveAccountAgenda"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  {isViewMode ? "visibility" : "event"}
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-3 text-white mb-0"
                  id="dateSpecificHoursLabel"
                >
                  {isViewMode
                    ? t("View Agenda Details")
                    : isDateSpecific
                      ? t("Date-Specific Hours")
                      : t("Save agenda")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {isViewMode
                    ? t("Review your agenda information")
                    : t("Configure your agenda details")}
                </p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2">
              {selectedAgendaId && (
                <button
                  type="button"
                  className="btn btn-outline-light btn-sm d-flex align-items-center gap-2"
                  onClick={toggleViewMode}
                  style={{ borderRadius: "8px" }}
                >
                  <span className="material-symbols-outlined fs-sm">
                    {isViewMode ? "edit" : "visibility"}
                  </span>
                  {isViewMode ? t("Edit") : t("View")}
                </button>
              )}
              <button
                type="button"
                className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetHandler}
              ></button>
            </div>
          </div>

          {/* Enhanced Modal Body */}
          <div
            className="modal-body p-4"
            style={{ backgroundColor: "var(--bs-gray-200)" }}
          >
            {/* Professional Card Layout */}
            <div className="p-3 p-md-4 border border-gray-300 rounded-15 shadow-sm bg-white">
              {isLoadingAgenda ? (
                // LOADING STATE WITH GLOW PLACEHOLDER
                <div className="loading-state">
                  {/* Loading Header */}
                  <div className="d-flex align-items-center gap-3 mb-4">
                    <div
                      className="rounded-circle bg-light"
                      style={{
                        width: "40px",
                        height: "40px",
                        background:
                          "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.5s infinite",
                      }}
                    ></div>
                    <div className="flex-grow-1">
                      <div
                        className="bg-light rounded mb-2"
                        style={{
                          height: "24px",
                          width: "200px",
                          background:
                            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite",
                        }}
                      ></div>
                      <div
                        className="bg-light rounded"
                        style={{
                          height: "16px",
                          width: "150px",
                          background:
                            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite",
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* Loading Content Cards */}
                  <div className="row mb-4">
                    <div className="col-md-8">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-header py-3">
                          <div
                            className="bg-light rounded"
                            style={{
                              height: "20px",
                              width: "150px",
                              background:
                                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "shimmer 1.5s infinite",
                            }}
                          ></div>
                        </div>
                        <div className="card-body p-4">
                          <div className="row g-4">
                            {/* Title placeholder */}
                            <div className="col-12">
                              <div className="d-flex align-items-center gap-3 mb-3">
                                <div
                                  className="bg-light rounded"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    background:
                                      "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                    backgroundSize: "200% 100%",
                                    animation: "shimmer 1.5s infinite",
                                  }}
                                ></div>
                                <div className="flex-grow-1">
                                  <div
                                    className="bg-light rounded mb-1"
                                    style={{
                                      height: "14px",
                                      width: "60px",
                                      background:
                                        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                      backgroundSize: "200% 100%",
                                      animation: "shimmer 1.5s infinite",
                                    }}
                                  ></div>
                                  <div
                                    className="bg-light rounded"
                                    style={{
                                      height: "20px",
                                      width: "180px",
                                      background:
                                        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                      backgroundSize: "200% 100%",
                                      animation: "shimmer 1.5s infinite",
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </div>

                            {/* Details placeholders */}
                            {[1, 2, 3, 4].map((item) => (
                              <div className="col-md-6" key={item}>
                                <div className="d-flex align-items-center gap-3">
                                  <div
                                    className="bg-light rounded"
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      background:
                                        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                      backgroundSize: "200% 100%",
                                      animation: "shimmer 1.5s infinite",
                                    }}
                                  ></div>
                                  <div className="flex-grow-1">
                                    <div
                                      className="bg-light rounded mb-1"
                                      style={{
                                        height: "12px",
                                        width: "80px",
                                        background:
                                          "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                        backgroundSize: "200% 100%",
                                        animation: "shimmer 1.5s infinite",
                                      }}
                                    ></div>
                                    <div
                                      className="bg-light rounded"
                                      style={{
                                        height: "16px",
                                        width: "120px",
                                        background:
                                          "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                        backgroundSize: "200% 100%",
                                        animation: "shimmer 1.5s infinite",
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Calendar sync placeholder */}
                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-header py-3">
                          <div
                            className="bg-light rounded"
                            style={{
                              height: "20px",
                              width: "120px",
                              background:
                                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                              backgroundSize: "200% 100%",
                              animation: "shimmer 1.5s infinite",
                            }}
                          ></div>
                        </div>
                        <div className="card-body p-4">
                          <div className="d-grid gap-3">
                            {[1].map((item) => (
                              <div
                                key={item}
                                className="bg-light rounded py-3"
                                style={{
                                  height: "48px",
                                  background:
                                    "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                  backgroundSize: "200% 100%",
                                  animation: "shimmer 1.5s infinite",
                                }}
                              ></div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Loading action buttons */}
                  <div className="d-flex align-items-center justify-content-between mt-4 pt-3 border-top border-gray-300">
                    <div
                      className="bg-light rounded"
                      style={{
                        height: "48px",
                        width: "140px",
                        background:
                          "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.5s infinite",
                      }}
                    ></div>
                    <div
                      className="bg-light rounded"
                      style={{
                        height: "48px",
                        width: "140px",
                        background:
                          "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.5s infinite",
                      }}
                    ></div>
                  </div>

                  {/* Add shimmer animation styles */}
                  <style>{`
                    @keyframes shimmer {
                      0% {
                        background-position: -200% 0;
                      }
                      100% {
                        background-position: 200% 0;
                      }
                    }
                  `}</style>
                </div>
              ) : isViewMode && agendaDetails ? (
                // VIEW MODE
                <div className="view-mode">
                  {/* Availability Status */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <div
                        className="alert border-0 rounded-10 d-flex align-items-center gap-3"
                        style={{
                          backgroundColor: agendaDetails.availability
                            ? "rgba(40, 167, 69, 0.1)"
                            : "rgba(220, 53, 69, 0.1)",
                          border: `1px solid ${
                            agendaDetails.availability
                              ? "rgba(40, 167, 69, 0.2)"
                              : "rgba(220, 53, 69, 0.2)"
                          }`,
                        }}
                      >
                        <div
                          className={`p-2 rounded-circle d-flex align-items-center justify-content-center`}
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: agendaDetails.availability
                              ? "var(--bs-success)"
                              : "var(--bs-danger)",
                          }}
                        >
                          <span className="material-symbols-outlined text-white fs-sm">
                            {agendaDetails.availability
                              ? "check_circle"
                              : "cancel"}
                          </span>
                        </div>
                        <div>
                          <h5
                            className="fw-bold mb-1"
                            style={{
                              color: agendaDetails.availability
                                ? "var(--bs-success)"
                                : "var(--bs-danger)",
                            }}
                          >
                            {agendaDetails.availability
                              ? t("Available")
                              : t("Not Available")}
                          </h5>
                          <p
                            className="fs-sm mb-0"
                            style={{
                              color: agendaDetails.availability
                                ? "var(--bs-success)"
                                : "var(--bs-danger)",
                            }}
                          >
                            {agendaDetails.datespecifichours
                              ? t("Date-specific availability")
                              : t("Regular availability slot")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Agenda Information */}
                  <div className="row mb-4">
                    <div className="col-md-8">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-header bg-primary text-white py-3">
                          <h6 className="mb-0 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined fs-sm">
                              event
                            </span>
                            {t("Agenda Information")}
                          </h6>
                        </div>
                        <div className="card-body p-4">
                          <div className="row g-4">
                            <div className="col-12">
                              <div className="d-flex align-items-center gap-3 mb-3">
                                <span className="material-symbols-outlined text-primary">
                                  description
                                </span>
                                <div>
                                  <label className="fs-sm text-muted fw-semibold">
                                    {t("Title")}
                                  </label>
                                  <p className="fw-bold mb-0 fs-5">
                                    {agendaDetails.description}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center gap-3">
                                <span className="material-symbols-outlined text-primary">
                                  event
                                </span>
                                <div>
                                  <label className="fs-sm text-muted fw-semibold">
                                    {t("Date")}
                                  </label>
                                  <p className="fw-bold mb-0">
                                    {new Date(
                                      agendaDetails.date
                                    ).toLocaleDateString()}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center gap-3">
                                <span className="material-symbols-outlined text-primary">
                                  timer
                                </span>
                                <div>
                                  <label className="fs-sm text-muted fw-semibold">
                                    {t("Duration")}
                                  </label>
                                  <p className="fw-bold mb-0">
                                    {calculateDurationInMinutes(
                                      agendaDetails.starttime,
                                      agendaDetails.endtime
                                    )}{" "}
                                    {t("minutes")}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center gap-3">
                                <span className="material-symbols-outlined text-primary">
                                  play_arrow
                                </span>
                                <div>
                                  <label className="fs-sm text-muted fw-semibold">
                                    {t("Start Time")}
                                  </label>
                                  <p className="fw-bold mb-0">
                                    {agendaDetails.starttime}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center gap-3">
                                <span className="material-symbols-outlined text-primary">
                                  stop
                                </span>
                                <div>
                                  <label className="fs-sm text-muted fw-semibold">
                                    {t("End Time")}
                                  </label>
                                  <p className="fw-bold mb-0">
                                    {agendaDetails.endtime}
                                  </p>
                                </div>
                              </div>
                            </div>
                            {agendaDetails.location && (
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-3">
                                  <span className="material-symbols-outlined text-primary">
                                    location_on
                                  </span>
                                  <div>
                                    <label className="fs-sm text-muted fw-semibold">
                                      {t("Location")}
                                    </label>
                                    <p className="fw-bold mb-0">
                                      {agendaDetails.location}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}

                            {agendaDetails.roomid && (
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-3">
                                  <span className="material-symbols-outlined text-primary">
                                    meeting_room
                                  </span>
                                  <div>
                                    <label className="fs-sm text-muted fw-semibold">
                                      {t("Room")}
                                    </label>
                                    <p className="fw-bold mb-0">
                                      {agendaDetails?.roomid?.roomname}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Calendar Sync */}
                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-header bg-success text-white py-3">
                          <h6 className="mb-0 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined fs-sm">
                              sync
                            </span>
                            {t("Calendar Sync")}
                          </h6>
                        </div>
                        <div className="card-body p-4">
                          <div className="d-grid gap-3">
                            <GoogleCalendarSync
                              agendaIds={[selectedAgendaId]}
                              token={token}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Company Details */}
                  {agendaDetails.companyvalue && (
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card border-0 shadow-sm">
                          <div className="card-header bg-info text-white py-3">
                            <h6 className="mb-0 d-flex align-items-center gap-2">
                              <span className="material-symbols-outlined fs-sm">
                                business
                              </span>
                              {t("Company Details")}
                            </h6>
                          </div>
                          <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-4">
                              <div
                                className="p-3 bg-info rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: "60px", height: "60px" }}
                              >
                                <span className="material-symbols-outlined text-white fs-4">
                                  business
                                </span>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="fw-bold mb-1">
                                  {agendaDetails.companyvalue.label}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Audit Information */}
                  {(agendaDetails.createdbyinfo || agendaDetails.updatedbyinfo) && (
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card border-0 shadow-sm">
                          <div className="card-header bg-secondary text-white py-3">
                            <h6 className="mb-0 d-flex align-items-center gap-2">
                              <span className="material-symbols-outlined fs-sm">
                                manage_accounts
                              </span>
                              {t("Audit Information")}
                            </h6>
                          </div>
                          <div className="card-body p-4">
                            <div className="row g-4">
                              {agendaDetails.createdbyinfo && (
                                <div className="col-md-6">
                                  <p className="fs-sm text-muted fw-semibold mb-2">
                                    {t("Created By")}
                                  </p>
                                  <div className="d-flex align-items-center gap-3">
                                    {agendaDetails.createdbyinfo.image ? (
                                      <img
                                        src={
                                          url.SERVER_URL +
                                          agendaDetails.createdbyinfo.image
                                        }
                                        alt={agendaDetails.createdbyinfo.name}
                                        className="rounded-circle object-fit-cover"
                                        style={{ width: "40px", height: "40px" }}
                                      />
                                    ) : (
                                      <div
                                        className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white fw-bold"
                                        style={{ width: "40px", height: "40px", fontSize: "1rem" }}
                                      >
                                        {agendaDetails.createdbyinfo.name
                                          ?.charAt(0)
                                          ?.toUpperCase()}
                                      </div>
                                    )}
                                    <div>
                                      <p className="fw-bold mb-0">
                                        {agendaDetails.createdbyinfo.name}
                                      </p>
                                      <p className="fs-sm text-muted mb-0">
                                        {agendaDetails.createdbyinfo.email}
                                      </p>
                                    </div>
                                  </div>
                                  {agendaDetails.createdAt && (
                                    <p className="fs-sm text-muted mt-2 mb-0">
                                      <span className="material-symbols-outlined fs-sm me-1" style={{ verticalAlign: "middle" }}>
                                        schedule
                                      </span>
                                      {new Date(agendaDetails.createdAt).toLocaleString()}
                                    </p>
                                  )}
                                </div>
                              )}
                              {agendaDetails.updatedbyinfo && (
                                <div className="col-md-6">
                                  <p className="fs-sm text-muted fw-semibold mb-2">
                                    {t("Last Updated By")}
                                  </p>
                                  <div className="d-flex align-items-center gap-3">
                                    {agendaDetails.updatedbyinfo.image ? (
                                      <img
                                        src={
                                          url.SERVER_URL +
                                          agendaDetails.updatedbyinfo.image
                                        }
                                        alt={agendaDetails.updatedbyinfo.name}
                                        className="rounded-circle object-fit-cover"
                                        style={{ width: "40px", height: "40px" }}
                                      />
                                    ) : (
                                      <div
                                        className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white fw-bold"
                                        style={{ width: "40px", height: "40px", fontSize: "1rem" }}
                                      >
                                        {agendaDetails.updatedbyinfo.name
                                          ?.charAt(0)
                                          ?.toUpperCase()}
                                      </div>
                                    )}
                                    <div>
                                      <p className="fw-bold mb-0">
                                        {agendaDetails.updatedbyinfo.name}
                                      </p>
                                      <p className="fs-sm text-muted mb-0">
                                        {agendaDetails.updatedbyinfo.email}
                                      </p>
                                    </div>
                                  </div>
                                  {agendaDetails.updatedAt && (
                                    <p className="fs-sm text-muted mt-2 mb-0">
                                      <span className="material-symbols-outlined fs-sm me-1" style={{ verticalAlign: "middle" }}>
                                        schedule
                                      </span>
                                      {new Date(agendaDetails.updatedAt).toLocaleString()}
                                    </p>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Action Buttons for View Mode */}
                  <div className="d-flex align-items-center justify-content-between mt-4 pt-3 border-top border-gray-300">
                    <button
                      type="button"
                      className="btn btn-outline-danger p-3 d-inline-flex align-items-center gap-2 rounded-15"
                      onClick={deleteAgendaHandler}
                      style={{
                        transition: "all 0.3s ease-in-out",
                        fontWeight: "600",
                      }}
                    >
                      <span className="material-symbols-outlined fs-md">
                        delete
                      </span>
                      <span>{t("Delete Agenda")}</span>
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary p-3 rounded-15 fw-bold d-inline-flex align-items-center gap-2"
                      onClick={toggleViewMode}
                      style={{
                        transition: "all 0.3s ease-in-out",
                        fontSize: "1rem",
                      }}
                    >
                      <span className="material-symbols-outlined fs-md">
                        edit
                      </span>
                      <span>{t("Edit Agenda")}</span>
                    </button>
                  </div>
                </div>
              ) : (
                // EDIT MODE (existing form code)
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="d-flex flex-column h-100"
                >
                  {/* Information Notice */}
                  <div
                    className="alert alert-primary border-0 rounded-10 mb-4 d-flex align-items-center gap-3"
                    style={{
                      backgroundColor: "rgba(var(--bs-primary-rgb), 0.1)",
                      border: "1px solid rgba(var(--bs-primary-rgb), 0.2)",
                    }}
                  >
                    <div
                      className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "var(--bs-primary)",
                      }}
                    >
                      <span className="material-symbols-outlined text-white fs-sm">
                        info
                      </span>
                    </div>
                    <div>
                      <p
                        className="fw-semibold mb-1"
                        style={{ color: "var(--bs-primary)" }}
                      >
                        {t("Time Slot Guidelines")}
                      </p>
                      <p
                        className="fs-sm mb-0"
                        style={{ color: "var(--bs-primary)" }}
                      >
                        ** {t("Each slot should be in 1 hour")}
                      </p>
                    </div>
                  </div>

                  <div className="form-group d-flex mb-4">
                    <div className="field-group d-flex flex-column gap-3 flex-fill">
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <div
                          className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "35px", height: "35px" }}
                        >
                          <span className="material-symbols-outlined text-white fs-sm">
                            description
                          </span>
                        </div>
                        <label
                          htmlFor="agendaTitle"
                          className="d-block fs-md fw-bold text-dark mb-0"
                        >
                          {t("Agenda Details")}
                        </label>
                      </div>

                      <div
                        className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                          border: "1px solid var(--bs-gray-300)",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                description
                              </span>
                              {t("Title")}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                event
                              </span>
                              {t("Date")}
                            </label>
                          </div>
                        </div>
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <input
                              type="text"
                              className={`form-control shadow-none fw-semibold border ${
                                validation.titleWarning
                                  ? "border-primary"
                                  : "border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("Enter title")}
                              value={agendaTitle}
                              onChange={(e) => {
                                setagendaTitle(e.target.value);
                                setValidation((prevState) => ({
                                  ...prevState,
                                  titleWarning: false,
                                }));
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="date"
                              className={`form-control shadow-none fw-semibold border ${
                                validation.dateWarning
                                  ? "border-primary"
                                  : "border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("Enter Date")}
                              value={agendaDate}
                              onChange={(e) => {
                                setagendaDate(e.target.value);
                                setValidation((prevState) => ({
                                  ...prevState,
                                  dateWarning: false,
                                }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <input
                              type="time"
                              className={`form-control shadow-none fw-semibold border ${
                                validation.startTimeWarning
                                  ? "border-primary"
                                  : "border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("Start Time")}
                              value={startTime}
                              onChange={(e) => {
                                setstartTime(e.target.value);
                                setendTime(calculateEndTime(1, e.target.value));
                                setValidation((prevState) => ({
                                  ...prevState,
                                  startTimeWarning: false,
                                  timeDiffWarning: false,
                                }));
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="time"
                              className={`form-control shadow-none fw-semibold border ${
                                validation.endTimeWarning ||
                                validation.timeDiffWarning
                                  ? "border-primary"
                                  : "border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("End Time")}
                              value={endTime}
                              onChange={(e) => {
                                setendTime(e.target.value);
                                setValidation((prevState) => ({
                                  ...prevState,
                                  endTimeWarning: false,
                                  timeDiffWarning: false,
                                }));
                              }}
                            />
                          </div>
                        </div>
                        {(validation.titleWarning ||
                          validation.dateWarning) && (
                          <div className="row g-3 mt-1">
                            <div className="col-md-6">
                              {validation.titleWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                  style={{
                                    fontSize: "0.75rem",
                                    margin: "0",
                                    width: "max-content",
                                  }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>{t("Please enter a title!")}</span>
                                </div>
                              )}
                            </div>
                            <div className="col-md-6">
                              {validation.dateWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                  style={{
                                    fontSize: "0.75rem",
                                    margin: "0",
                                    width: "max-content",
                                  }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>{t("Please enter date!")}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="d-flex align-items-center gap-2 mb-3">
                        <div
                          className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "35px", height: "35px" }}
                        >
                          <span className="material-symbols-outlined text-white fs-sm">
                            access_time
                          </span>
                        </div>
                        <label
                          htmlFor="timing"
                          className="d-block fs-md fw-bold text-dark mb-0"
                        >
                          {t("Timings")}
                        </label>
                      </div>

                      <div
                        className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                          border: "1px solid var(--bs-gray-300)",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                play_arrow
                              </span>
                              {t("Start Time")}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                stop
                              </span>
                              {t("End Time")}
                            </label>
                          </div>
                        </div>
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <input
                              type="time"
                              className={`form-control shadow-none fw-semibold border ${
                                validation.startTimeWarning
                                  ? "border-primary"
                                  : "border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("Start Time")}
                              value={startTime}
                              onChange={(e) => {
                                setstartTime(e.target.value);
                                setendTime(calculateEndTime(1, e.target.value));
                                setValidation((prevState) => ({
                                  ...prevState,
                                  startTimeWarning: false,
                                  timeDiffWarning: false,
                                }));
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <input
                              type="time"
                              className={`form-control shadow-none fw-semibold border ${
                                validation.endTimeWarning ||
                                validation.timeDiffWarning
                                  ? "border-primary"
                                  : "border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("End Time")}
                              value={endTime}
                              onChange={(e) => {
                                setendTime(e.target.value);
                                setValidation((prevState) => ({
                                  ...prevState,
                                  endTimeWarning: false,
                                  timeDiffWarning: false,
                                }));
                              }}
                            />
                          </div>
                        </div>
                        {(validation.startTimeWarning ||
                          validation.endTimeWarning ||
                          validation.timeDiffWarning) && (
                          <div className="row g-3 mt-1">
                            <div className="col-md-6">
                              {validation.startTimeWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                  style={{
                                    fontSize: "0.75rem",
                                    margin: "0",
                                    width: "max-content",
                                  }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>{t("Please enter start time!")}</span>
                                </div>
                              )}
                            </div>
                            <div className="col-md-6">
                              {validation.endTimeWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                  style={{ fontSize: "0.75rem", margin: "0" }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>{t("Please enter a end time!")}</span>
                                </div>
                              )}
                              {validation.timeDiffWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2 mt-1"
                                  style={{ fontSize: "0.75rem", margin: "0" }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>
                                    End time should not be less then start time!
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="d-flex align-items-center gap-2 mb-3">
                        <div
                          className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "35px", height: "35px" }}
                        >
                          <span className="material-symbols-outlined text-white fs-sm">
                            location_on
                          </span>
                        </div>
                        <label
                          htmlFor="location"
                          className="d-block fs-md fw-bold text-dark mb-0"
                        >
                          {t("Location")}
                        </label>
                      </div>
                      <div
                        className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative overflow-hidden"
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                          border: "1px solid var(--bs-gray-300)",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <div className="row g-3 mb-2">
                          <div className="col-md-12">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                location_on
                              </span>
                              {t("Location")}
                            </label>
                          </div>
                        </div>
                        <div className="row g-3 mb-2">
                          <div className="col-md-12">
                            <input
                              type="text"
                              className="form-control shadow-none border border-gray-300 fw-semibold"
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("Enter location")}
                              value={location}
                              onChange={(e) => {
                                setLocation(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-2 mb-3">
                        <div
                          className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "35px", height: "35px" }}
                        >
                          <span className="material-symbols-outlined text-white fs-sm">
                            business
                          </span>
                        </div>
                        <label
                          htmlFor="company"
                          className="d-block fs-md fw-bold text-dark mb-0"
                        >
                          {t("Company")}
                        </label>
                      </div>
                      <div
                        className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative"
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                          border: "1px solid var(--bs-gray-300)",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <div className="row g-3 mb-2">
                          <div className="col-md-12">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                business
                              </span>
                              {t("Select Company")}
                            </label>
                          </div>
                        </div>
                        <div className="row g-3 mb-2">
                          <div className="col-md-12">
                            <AsyncSelect
                              isClearable
                              name="company"
                              loadOptions={loadCompanyOptions}
                              defaultOptions={false}
                              cacheOptions={false}
                              placeholder={t("Type company name")}
                              styles={reactSelectStyle(
                                "3px",
                                "6px",
                                true,
                                false
                              )}
                              value={company}
                              onChange={(val) => {
                                if (val) {
                                  setCompany(val);
                                  loadRoomOptions(val?.value);
                                } else {
                                  setCompany(null);
                                  setRoomOptions([]);
                                  setSelectedRoom(null);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-2 mb-3">
                        <div
                          className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "35px", height: "35px" }}
                        >
                          <span className="material-symbols-outlined text-white fs-sm">
                            meeting_room
                          </span>
                        </div>
                        <label
                          htmlFor="room"
                          className="d-block fs-md fw-bold text-dark mb-0"
                        >
                          {t("Room")}
                        </label>
                      </div>
                      <div
                        className="field-container p-4 rounded-15 shadow-sm mb-4 position-relative"
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(248, 249, 250, 1) 100%)",
                          border: "1px solid var(--bs-gray-300)",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <div className="row g-3 mb-2">
                          <div className="col-md-12">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                meeting_room
                              </span>
                              {t("Enter Room")}
                            </label>
                          </div>
                        </div>
                        <div className="row g-3 mb-2">
                          <div className="col-md-12">
                            <Select
                              placeholder="Select room"
                              styles={reactSelectStyle(
                                "3px",
                                "6px",
                                true,
                                false
                              )}
                              isDisabled={!company || company === null}
                              options={roomOptions}
                              value={selectedRoom}
                              onChange={(val) => {
                                setSelectedRoom(val);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="action d-flex align-items-center justify-content-end mt-4 pt-3 border-top border-gray-300">
                    <button
                      type="button"
                      className="btn btn-primary p-3 rounded-15 fw-bold d-inline-flex align-items-center gap-2"
                      onClick={saveAgendaHandler}
                      style={{
                        transition: "all 0.3s ease-in-out",
                        fontSize: "1rem",
                      }}
                    >
                      <span className="material-symbols-outlined fs-md">
                        save
                      </span>
                      <span>{t("Save Agenda")}</span>
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveAgendaModal;